import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "discounts",
    object: "discount",
    header: [
      { text: "Código", value: "code" },
      { text: "Descuento %", value: "discount" },
      { text: "Veces usado", value: "quantity_used" },
      { text: "Limite de usos", value: "quantity_limit" },
      { text: "Limite de usos por cita", value: "app_quantity_limit" },
      { text: "Limite de usos por cita con descuento", value: "app_quantity_limit_with_discount" },
      { text: "Estado", value: "active" },
    ],
    options: {
      sortBy: ["_id"],
      sortDesc: [true]
    }
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions
  },
  getters: {
    ...genericStore.getters
  }
};
